import common from './items/common.json'
import validation from './items/validation.json'
import pages from './items/pages.json'

const translations = {
  common,
  validation,
  pages,
}
export default translations
